import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { CallBar } from '../CallBar/CallBar';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';

const CallBarManager = () => {
  const { callList, callAttributes } = usePhoneState();
  const { selectedTaskId } = useInboxState();

  const allCallsHeld = callList.every((call) => call.held);

  return callList.map((call) => {
    const attributes = {
      ...callAttributes[call.callId],
      queueIds: callAttributes[call.callId]?.queueIds
        ? [...callAttributes[call.callId].queueIds]
        : [],
      traits: callAttributes[call.callId]?.traits
        ? [...callAttributes[call.callId].traits]
        : [],
    };

    // if all calls are held, show the call bar for selected task
    const showSelectedCallBar =
      allCallsHeld &&
      !!selectedTaskId &&
      selectedTaskId === attributes.pcsConversationSid;

    return (
      <CallBar
        key={call.callId}
        callState={call}
        show={!call.held || showSelectedCallBar}
      />
    );
  });
};

export default CallBarManager;
